// @mui
import { useTheme } from "@mui/material/styles";
import { Stack, AppBar, Toolbar, IconButton, Link, Box } from "@mui/material";
import { useSettingsContext } from "../../components/settings";
import useResponsive from "../../hooks/useResponsive";
import useOffSetTop from "../../hooks/useOffSetTop";
// import Iconify from "../../components/iconify";
import { HEADER, TELEGRAM_SUPPORT_URL, V1_API_URL } from "../../config";
import { bgBlur } from "../../utils/cssStyles";
import { useLocales } from "@/locales";
import { useContext } from "react";
import { MyLayoutContext } from "..";
import ShowSearchBtn from "@/components/SearchDoc/ShowSearchBtn";
// import SelectLangsBtn from "./SelectLangsBtn";

type Props = {
  onOpenNav?: VoidFunction;
};

export default function Header({ onOpenNav }: Props) {
  const { translate } = useLocales();
  const theme = useTheme();

  const { themeLayout } = useSettingsContext();

  const isNavHorizontal = themeLayout === "horizontal";

  const isNavMini = themeLayout === "mini";

  const isDesktop = useResponsive("up", "lg");

  const isMobile = useResponsive("down", "sm");

  const isOffset =
    useOffSetTop(HEADER.H_DASHBOARD_DESKTOP_OFFSET) && !isNavHorizontal;

  const { setNavOpen } = useContext(MyLayoutContext);

  const renderContent = (
    <>
      {!isDesktop && (
        <IconButton
          onClick={() => {
            setNavOpen(true);
          }}
          sx={{ mr: 1, color: "text.primary" }}
        >
          {/* <Iconify icon="eva:menu-2-fill" /> */}

          <Box
            component={"span"}
            className="icon-menu-right"
            fontSize={isDesktop ? 24 : 20}
          />
        </IconButton>
      )}

      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={{ xs: 0.5, sm: 1.5 }}
        sx={{
          color: theme.palette.text.primary,
        }}
      >
        <ShowSearchBtn />
        {/* <SelectLangsBtn /> */}
        {!isMobile && (
          <>
            <Link
              href={V1_API_URL}
              underline="hover"
              target="_blank"
              sx={{ marginLeft: "40px !important" }}
            >
              {translate("header.api_interface")}
              {/* <span
            style={{
              background: "rgba(113, 117, 126, 0.1)",
              borderRadius: "8px",
              padding: "2px 6px",
            }}
          >
            {translate("header.api_tip")}
          </span> */}
            </Link>
            {/* <Box>{translate("header.update_log")}</Box> */}
            {/* <Link href={CCPAYMENT_BLOG_URL} target="_blank" underline="hover">
          {translate("header.blog")}
        </Link> */}
            <Link
              href={TELEGRAM_SUPPORT_URL}
              underline="hover"
              target="_blank"
              sx={{ marginLeft: "40px !important" }}
            >
              {translate("header.faq_desc")}
            </Link>
          </>
        )}

        {/* <SelectLangsBtn /> */}
      </Stack>
    </>
  );

  return (
    <AppBar
      position={isDesktop ? "sticky" : "fixed"}
      sx={{
        boxShadow: "none",
        borderBottom: `1px solid ${theme.palette.text.stroke}`,
        height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
        minHeight: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          opacity: theme.palette.mode === "light" ? 1 : 1,
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(["height"], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(isDesktop && {
          // width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
          height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
          ...(isOffset && {
            height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
          }),
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: "background.default",
            height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
            borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
          }),
          ...(isNavMini && {
            // width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`,
            width: 1,
          }),
        }),
      }}
    >
      <Toolbar
        variant="dense"
        sx={{
          height: 1,
          minHeight: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}
